import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconsModule } from '@ng-icons/core';
import {
  NgxFloatUiModule,
  NgxFloatUiPlacements,
  NgxFloatUiTriggers,
} from 'ngx-float-ui';

@NgModule({
  imports: [
    NgxFloatUiModule.forRoot({
      placement: NgxFloatUiPlacements.TOP,
      trigger: NgxFloatUiTriggers.hover,
      positionFixed: true,
    }),
  ],
  exports: [TranslateModule, CommonModule, NgIconsModule, NgxFloatUiModule],
})
export class AppSharedModule {}
